import { CAMPAIGN_STATUS } from '@/client/constant'
import { isPeriodEndAfterNttAaaSwitchover } from '@/common/utils'
import { TCampaign } from '@/typings/api/campaigns.type'

/**
 * URL 設定催促アラート・URL 設定アイコンの表示対象
 */
const REPOST_ENTRY_ACTION_TYPES = ['retweet', 'quote_tweet', 'retweet_and_quote_tweet']

// 「開催中」に対応する CAMPAIGN_STATUS 値（design.md 対応表: 1=応募収集待ち / 2=初回応募収集完了）
const STARTED_EVENT_STATUSES: number[] = [CAMPAIGN_STATUS.BEFORE_COLLECTION, CAMPAIGN_STATUS.DURING_COLLECTION]

/**
 * 対象種別（リポスト/引用系 3 種）かどうかを判定する。
 */
export const isRepostEntryActionType = (entryActionType: string | null | undefined): boolean =>
  entryActionType != null && REPOST_ENTRY_ACTION_TYPES.includes(entryActionType)

/**
 * 応募収集 URL 設定の対象キャンペーンかどうかを判定する。
 */
const isUrlSettingTargetCampaign = (campaign: Pick<TCampaign, 'entryActionType' | 'type' | 'targetSns'>): boolean =>
  campaign.targetSns === 'twitter' && campaign.type === 'keyword' && isRepostEntryActionType(campaign.entryActionType)

/** URL 設定アイコンを行に表示すべきか */
export const shouldShowUrlSettingIcon = (
  campaign: Pick<TCampaign, 'entryActionType' | 'type' | 'targetSns' | 'endDatetime'>
): boolean => isUrlSettingTargetCampaign(campaign) && isPeriodEndAfterNttAaaSwitchover(campaign.endDatetime)

/**
 * URL 設定催促アラート内容を表示する
 */
export const filterUnsetUrlSettingCampaigns = <
  T extends Pick<TCampaign, 'entryActionType' | 'type' | 'targetSns' | 'hasTweetPostUrl' | 'status' | 'endDatetime'>
>(
  campaigns: T[]
): T[] =>
  campaigns.filter(
    campaign =>
      isUrlSettingTargetCampaign(campaign) &&
      STARTED_EVENT_STATUSES.includes(campaign.status) &&
      isPeriodEndAfterNttAaaSwitchover(campaign.endDatetime) &&
      !campaign.hasTweetPostUrl
  )

/**
 * URL 設定催促アラートを表示すべきか判定する。
 */
export const hasUnsetUrlSettingAlertTarget = (
  campaigns: Pick<TCampaign, 'entryActionType' | 'type' | 'targetSns' | 'hasTweetPostUrl' | 'status' | 'endDatetime'>[]
): boolean => filterUnsetUrlSettingCampaigns(campaigns).length > 0
